import { StateDeclaration } from './state-declaration.js';

export function defineState<T extends StateDeclaration<any, any, any, any>[]>(
  val: T,
): { [Prop in T[number] as Prop['name']]: Prop } {
  return val.reduce<any>((map, evt) => {
    map[evt.name] = evt;
    return map;
  }, {});
}
